// @flow
import ConnectionTimeOut from './ConnectionTimeOut';

export default ConnectionTimeOut;
